export * from './get-connector-current-limit-from-config'
